export const GADAI = {
    METODE_PENCAIRAN: {
        TUNAI: 0,
        NON_TUNAI: 1,
    },
    STATUS_DISBURSEMENT_APPROVAL: {
        PENDING: 0,
        APPROVED: 1,
        REJECTED: 2,
        CANCELLED: 10,
    },
    STATUS_DISBURSEMENT_GADAI: {
        WAIT_APPROVAL: 0,
        APPROVED_ALL: 1,
        DISBURSED: 2,
        DANA_DITANGGUHKAN: 5,
        DANA_DITANGGUHKAN_GAGAL: 6,
        CEK_IT: 7,
        CANCELLED: 10,
        REJECTED: 11,
    },
    STATUS_DISBURSEMENT_PENDING: {
        PENDING: 1,
        WAITING_BANK_RESPONSE: 2,
        PROCESS_SHORTFALL: 3,
        PROCESS_REFUND: 4,
        FAILED: 5,
        COMPLETED: 9,
    },
    JENIS: {
        ELEKTRONIK: 1,
        EMAS: 3
    }
}
